var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2398 7.75969C16.7977 8.31693 17.2402 8.97866 17.5422 9.70705C17.8441 10.4354 17.9995 11.2162 17.9995 12.0047C17.9995 12.7932 17.8441 13.5739 17.5422 14.3023C17.2402 15.0307 16.7977 15.6924 16.2398 16.2497M7.75982 16.2397C7.20196 15.6824 6.75941 15.0207 6.45746 14.2923C6.15551 13.5639 6.0001 12.7832 6.0001 11.9947C6.0001 11.2062 6.15551 10.4254 6.45746 9.69705C6.75941 8.96866 7.20196 8.30693 7.75982 7.74969M19.0698 4.92969C20.9445 6.80496 21.9977 9.34805 21.9977 11.9997C21.9977 14.6513 20.9445 17.1944 19.0698 19.0697M4.92982 19.0697C3.05511 17.1944 2.00195 14.6513 2.00195 11.9997C2.00195 9.34805 3.05511 6.80496 4.92982 4.92969M13.9998 12C13.9998 13.1046 13.1043 14 11.9998 14C10.8952 14 9.99976 13.1046 9.99976 12C9.99976 10.8954 10.8952 10 11.9998 10C13.1043 10 13.9998 10.8954 13.9998 12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.e8432ada02d4fe7e04be2df80aa8d211.svg";
export { ForwardRef as ReactComponent };